import React, {useEffect, useState} from 'react';
import {WrapUpStory, WrapUpStoryProps} from "../components/wrap-up-story";
import type {EBirdMyDataSchemaWithImage} from "./discover/big-year/types";
import {useProcessStories} from "../helpers/useProcessStories";

export type WrapUpProps = {
    observations: EBirdMyDataSchemaWithImage[],
    year?: string | number,
    month?: string | number,
}



export default function WrapUp({observations, year, month}: WrapUpProps) {
    const [stories, setStories] = useState<WrapUpStoryProps[]>([]);
    const {processStories} = useProcessStories();

    useEffect(() => {
        const stories = processStories({year, month, observations});
        setStories(stories);
    }, [observations, processStories, year, month]);

    return (
        <div className="my-5">
            <div className="card">
                <h1 className="card__title">
                    Here's your 2020 wrap-up!
                </h1>
                <p className="card__subtitle">You had quite a year and racked up over 2500 birds from 260 different species! Here are some of the highlights.</p>
            </div>

            {stories?.map(storyProps => (
                <WrapUpStory key={storyProps.storyKey} {...storyProps} />
            ))}
        </div>
    )
}
